import React, { PureComponent } from 'react'
import { Link, Redirect } from 'react-router-dom'
import { Field, reduxForm } from 'redux-form'
import { Button, Alert } from 'react-bootstrap'
import InputText from '../../components/commons/form/InputText'
import InputPassword from '../../components/commons/form/InputPassword'
import Access from '../../components/Access'
import settings from '../../setting'
import { setThemeClass } from '../../util/theme.js'

const validate = (values, { t }) => {
  const errors = {}
  if (!values.emailAddress) {
    errors.emailAddress = t('GLOBAL.FORMS.REQUIRED')
  } else if (!/^[A-Z0-9._%+-Ñ]+@[A-Z0-9._%+-Ñ]+\.[A-Z]{2,4}$/i.test(values.emailAddress)) {
    errors.emailAddress = t('GLOBAL.FORMS.INVALID_EMAIL_ADDRESS')
  }
  if (!values.password) errors.password = t('GLOBAL.FORMS.REQUIRED')
  return errors
}

class Login extends PureComponent {
  constructor (props) {
    super(props)
    this.onSubmit = this.onSubmit.bind(this)
  }

  onSubmit (values) {
    return new Promise((resolve, reject) => {
      this.props.actions.fetchAuth(values, resolve, reject, this.props.t)
    })
  }

  render () {
    const { t, handleSubmit, error, invalid, submitting, /* actions: { fetchAuth }, */ submitSucceeded, sections, nonUpdatedSalesControl } = this.props
    const redirection = this.props.location.hash
    var dataTheme = localStorage.getItem('theme')
    setThemeClass(dataTheme)
    let CompanyLogo
    let poweredBy
    switch (dataTheme) {
      case 'dark':
        CompanyLogo = <img src='images/CompanyLogoD.png'></img>
        poweredBy = <img src="images/poweredbyD.png" ></img>
        break
      default:
        CompanyLogo = <img src='images/CompanyLogo.png'></img>
        poweredBy = <img src="images/poweredby.png" ></img>
        break
    }
    if (submitSucceeded && sections?.length > 0) {
      if (redirection) {
        return <Redirect to={redirection.substring(1)} />
      } else {
        if (!nonUpdatedSalesControl) {
          return <Redirect to={'/' + sections[0].code} />
        } else {
          return <Redirect to={'/nonUpdatedDossiers'} />
        }
      }
    }
    return (
      <Access>
        <div className='loginContainer'>
          <form className="auth" onSubmit={handleSubmit(this.onSubmit)}>
            <div className='elementContainer'>
              <div className='clientBox'>
                <h2>Welcome to</h2>
                {CompanyLogo}
              </div>
              <div className='loginBox'>
                {poweredBy}
                <h1 className="logintext">{t('LOGIN.LOGIN')}</h1>
                <div className='fieldsContainer'>
                  <Field
                    colSm={12}
                    colSmOffset={1}
                    id='emailAddress'
                    name='emailAddress'
                    placeholder={t('LOGIN.EMAIL')}
                    controlLabel={t('LOGIN.EMAIL')}
                    component={InputText}
                  />
                  <Field
                    t={t}
                    colSm={12}
                    colSmOffset={1}
                    id='password'
                    name='password'
                    placeholder={t('LOGIN.PASSWORD')}
                    controlLabel={t('LOGIN.PASSWORD')}
                    component={InputPassword}
                  />
                  {error &&
                      <Alert bsStyle='danger' role='alert'><p>{error}</p></Alert>
                  }
                </div>
                <div className='flexInLine al-C'>
                  <Button
                    id='btn_login'
                    type='submit'
                    bsStyle='primary'
                    className='_Btn accept'
                    name='btnLogin'
                    disabled={invalid || submitting}
                  >
                    {t('LOGIN.LOG_IN')}
                  </Button>
                  <Link id='lnk_remember' to={'/remember-password'} className="remember-password">
                    {t('LOGIN.FORGOT_PASSWORD')}
                  </Link>
                </div>
                <div className='versionBox'>
                  <span className='version'>v.{settings.version}</span>
                  {settings.environmentName &&
                    <span className={'enviroment ' + (settings.environmentName)}>{settings.environmentName}</span>
                  }
                </div>
              </div>
            </div>
          </form>
        </div>
        <div className='transpContainer'></div>

      </Access>
    )
  }
}

export default reduxForm({
  form: 'login',
  validate
})(Login)
